import { render } from "./CourseSnapContrast.vue?vue&type=template&id=b5f1b8e4&scoped=true"
import script from "./CourseSnapContrast.vue?vue&type=script&lang=js"
export * from "./CourseSnapContrast.vue?vue&type=script&lang=js"

import "./CourseSnapContrast.vue?vue&type=style&index=0&id=b5f1b8e4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f1b8e4"]])

export default __exports__